export default function getRoom ({ node }) {
  return `Room ${node.field_room_number}`;
}
